module.exports = __webpack_public_path__ + "img/pdf.a6b7fec1.png";